import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const groupProgressManagement = createApi({
    reducerPath: "groupProgressManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        groupProgressList: builder.mutation({
            query: () => ({
                url: `v1/${locale}/settings/group-progress`,
                method: "GET",
                
            }),
        }),
        viewGroupProgress: builder.mutation({
            query: (settingsGroupProgressId) => ({
                url: `v1/${locale}/settings/group-progress/${settingsGroupProgressId}`,
                method: "GET",
            }),
        }),

        addGroupProgress: builder.mutation({
            query: (body) => ({
                url: `v1/${locale}/settings/group-progress`,
                method: "POST",
                body: body,
            }),
        }),

        updateGroupProgress: builder.mutation({
            query: ({ body, settingsGroupProgressId }) => ({
                url: `v1/${locale}/settings/group-progress/${settingsGroupProgressId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteGroupProgress: builder.mutation({
            query: (settingsGroupProgressId) => ({
                url: `v1/${locale}/settings/group-progress/${settingsGroupProgressId}`,
                method: "DELETE",
            }),
        }),

        listGroupProgressType: builder.mutation({
            query: (settingsGroupProgressId) => ({
                url: `v1/${locale}/settings/group-progress/${settingsGroupProgressId}/type`,
                method: "GET",
            }),
        }),

        viewGroupProgressType: builder.mutation({
            query: ({groupProgressId, groupProgressTypeId}) => ({
                url: `v1/${locale}/settings/group-progress/${groupProgressId}/type/${groupProgressTypeId}`,
                method: "GET",
            }),
        }),

        updateGroupProgressType: builder.mutation({
            query: ({body, groupProgressId, groupProgressTypeId}) => ({
                url: `v1/${locale}/settings/group-progress/${groupProgressId}/type/${groupProgressTypeId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        addGroupProgressType: builder.mutation({
            query: ({ body, settingsGroupProgressId, groupTypeId }) => ({
                url: `v1/${locale}/settings/group-progress/${settingsGroupProgressId}/type/${groupTypeId}`,
                method: "POST",
                body: body,
            }),
        }),

        deleteGroupProgressType: builder.mutation({
            query: ({settingsGroupProgressId, groupTypeId}) => ({
                url: `v1/${locale}/settings/group-progress/${settingsGroupProgressId}/type/${groupTypeId}`,
                method: "DELETE",
            }),
        }),

        listGroupGroupProgressTypeOption: builder.mutation({
            query: ({settingsGroupProgressTypeId}) => ({
                url: `v1/${locale}/settings/group-progress-type/${settingsGroupProgressTypeId}/option`,
                method: "GET",
            }),
        }),

        addGroupGroupProgressTypeOption: builder.mutation({
            query: ({ settingsGroupProgressTypeId, body }) => ({
                url: `v1/${locale}/settings/group-progress-type/${settingsGroupProgressTypeId}/option`,
                method: "POST",
                body: body,
            }),
        }),

        viewGroupGroupProgressTypeOption: builder.mutation({
            query: ({ groupProgressTypeId, settingsGroupProgressTypeOptionId }) => ({
                url: `v1/${locale}/settings/group-progress-type/${groupProgressTypeId}/option/${settingsGroupProgressTypeOptionId}`,
                method: "GET",
            }),
        }),

        updateGroupGroupProgressTypeOption: builder.mutation({
            query: ({ body, groupProgressTypeId, settingsGroupProgressTypeOptionId }) => ({
                url: `v1/${locale}/settings/group-progress-type/${groupProgressTypeId}/option/${settingsGroupProgressTypeOptionId}`,
                method: "PATCH",
                body: body,
            }),
        }),

        deleteGroupGroupProgressTypeOption: builder.mutation({
            query: ({settingsGroupProgressTypeId, optionId}) => ({
                url: `v1/${locale}/settings/group-progress-type/${settingsGroupProgressTypeId}/option/${optionId}`,
                method: "DELETE",
            }),
        }),

        groupProgressByGroupType: builder.mutation({
            query: ({ groupTypeId }) => ({
                url: `v1/${locale}/settings/group-progress/groupType/${groupTypeId}`,
                method: "GET",
            }),
        }),

        groupProgressTypeOptionByGroupType: builder.mutation({
            query: ({ settingsGroupProgressId, groupTypeId }) => ({
                url: `v1/${locale}/settings/group-progress/${settingsGroupProgressId}/type-option/groupType/${groupTypeId}`,
                method: "GET",
            }),
        }),
    }),
});

export const { 
    useGroupProgressListMutation,
    useAddGroupProgressMutation,
    useViewGroupProgressMutation,
    useUpdateGroupProgressMutation,
    useDeleteGroupProgressMutation,
    useListGroupProgressTypeMutation,
    useViewGroupProgressTypeMutation,
    useUpdateGroupProgressTypeMutation,
    useAddGroupProgressTypeMutation,
    useDeleteGroupProgressTypeMutation,
    useListGroupGroupProgressTypeOptionMutation,
    useAddGroupGroupProgressTypeOptionMutation,
    useUpdateGroupGroupProgressTypeOptionMutation,
    useViewGroupGroupProgressTypeOptionMutation,
    useDeleteGroupGroupProgressTypeOptionMutation,
    useGroupProgressByGroupTypeMutation,
    useGroupProgressTypeOptionByGroupTypeMutation
} = groupProgressManagement;
